"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Button = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _ = require("../..");

var _icons = require("../../../icons");

var styles = _interopRequireWildcard(require("./button.module.scss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const Button = _ref => {
  let {
    size,
    type,
    color,
    children,
    icon,
    active,
    wrapper: Wrapper,
    className,
    ...props
  } = _ref;
  const wrapperClassName = (0, _react.useMemo)(() => [styles.wrapper, styles[size], styles[type], styles[color], active ? styles.active : "", className].filter(Boolean).join(" "), [size, type, color, active, className]);
  size = (0, _react.useMemo)(() => {
    switch (size) {
      case "sm":
        return "s2";

      case "lg":
        return "s4";

      default:
        return "s3";
    }
  }, [size]);
  return /*#__PURE__*/_react.default.createElement(Wrapper, _extends({
    className: wrapperClassName
  }, props), icon && /*#__PURE__*/_react.default.createElement("span", {
    className: styles.icon
  }, icon), /*#__PURE__*/_react.default.createElement(_.Text, {
    color: "inherit",
    size: size,
    wrapper: "span",
    className: styles.text
  }, children), type === "minimal" && /*#__PURE__*/_react.default.createElement(_icons.ArrowIcon, {
    className: styles.arrow
  }));
};

exports.Button = Button;
Button.defaultProps = {
  size: "md",
  icon: null,
  color: "black",
  type: "initial",
  wrapper: "button",
  onClick: () => {},
  className: null,
  active: false
};
Button.propTypes = {
  icon: _propTypes.default.element,
  onClick: _propTypes.default.func,
  size: _propTypes.default.oneOf(["sm", "md", "lg"]),
  type: _propTypes.default.oneOf(["initial", "minimal", "invert", "border"]),
  color: _propTypes.default.oneOf(["inherit", "black", "white", "primary"]),
  wrapper: _propTypes.default.elementType,
  className: _propTypes.default.string,
  active: _propTypes.default.bool
};